export const ALLERGY_RAW_MATERIALS_TYPE = 1;
export const QUASI_RAW_MATERIALS_TYPE = 2;
